module.exports = __webpack_public_path__ + "img/train.2c5d1bbf.gif";